<template>
    <div class="tw-grid tw-grid-cols-12">
        <div class="lg:tw-col-start-2 lg:tw-col-end-12 tw-col-span-12">
            <div v-for="block in organism.content_blocks" :key="block">
                <div v-html="block.content" class="tw-prose tw-prose-invert tw-max-w-none tw-mb-8 tw-clear-both"/>
                <div
                    v-if="block.question"
                    class="tw-grid-gap tw-bg-[#375D3F]/30 tw-p-6 tw-clear-both tw-rounded-4xl tw-mb-6"
                    :class="block.question.image ? 'tw-grid tw-grid-cols-12 tw-justify-center tw-items-center' : 'tw-flex tw-justify-center'"
                >
                    <div
                        class="tw-flex tw-items-center"
                        :class="block.question.image ? 'tw-col-span-12 lg:tw-col-span-7' : 'max-w-2xl'"
                    >
                        <organisms-question
                            :question="block.question"
                            :show-next-button="false"
                        />
                    </div>
                    <div v-if="block.question.image" class="tw-col-span-12 lg:tw-col-span-5 lg:tw-flex tw-justify-end tw-items-center">
                        <img
                            v-if="block.question.image"
                            :src="block.question.image"
                            :alt="block.question.title"
                            class="tw-w-80 tw-h-80 tw-object-cover tw-rounded-4xl"
                        >
                    </div>
                </div>
            </div>
            <div class="tw-grid tw-grid-gap tw-grid-cols-12 tw-my-10 tw-clear-both">
                <div
                    v-if="organism.characteristic_1"
                    class="lg:tw-col-span-5 md:tw-col-span-6 tw-col-span-12"
                >
                    <div class="tw-bg-white tw-rounded-3xl tw-p-6 lg:tw-p-10 tw-text-primary">
                        <h3>{{ organism.characteristics_title }}</h3>
                        <ul class="tw-space-y-4 tw-pl-0 tw-mb-0">
                            <template v-for="index in 4">
                                <li
                                    v-if="organism['characteristic_' + index]"
                                    class="tw-flex tw-items-center tw-gap-4"
                                    :key="index"
                                >
                                    <i class="fa fa-check-circle tw-text-primary-300"></i>
                                    {{ organism['characteristic_' + index] }}
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
                <div class="lg:tw-col-span-5 md:tw-col-span-6 tw-col-span-12">
                    <div class="tw-bg-white tw-rounded-3xl tw-p-6 lg:tw-p-10 tw-text-primary tw-space-y-6 sm:tw-space-y-8 lg:tw-space-y-12">
                        <img class="tw-max-w-[9rem]" src="../../img/groen-kennisnet.svg" alt="">
                        <h2 class="!tw-text-primary tw-text-4xl">Bekijk het gehele dossier op Groen Kennisnet</h2>
                        <a
                            href="https://groenkennisnet.nl/dossier/q-organismen-boomkwekerij-dossier"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="tw-button"
                        >
                            Meer informatie
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OrganismsQuestion from './OrganismsQuestion';

export default {
  props: {
    organism: {
      type: Object,
      required: true,
    },
  },
  components: {OrganismsQuestion},
};
</script>
